import { blue6, gold6, grey7, grey9, red6 } from "./colors";

/*
SIZES
 */
export const FONT_SIZE_DEFAULT = "14px";
export const FONT_SIZE_LARGE = "16px";
export const FONT_SIZE_SMALL = "12px";

/*
WEIGHTS
 */
export const FONT_WEIGHT_DEFAULT = 300;
export const FONT_WEIGHT_HEAVY = 500;

/*
COLOURS
 */
export const FONT_COLOR_DEFAULT = grey9;
export const FONT_COLOR_MUTED = grey7;
export const FONT_COLOR_PRIMARY = blue6;
export const FONT_COLOR_INFO = blue6;
export const FONT_COLOR_ERROR = red6;
export const FONT_COLOR_WARNING = gold6;

/*
FONT FAMILIES
 */
export const ANT_DESIGN_FONT_FAMILY = `-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif`;
